<template>
    <div class="container">
        <div class="agentAdd">
            <van-form @submit="onSubmit" validate-trigger='onSubmit' :validate-first="true">
                <van-field v-model="addressInfo.agentNickName" name="validatorName" label="昵称" placeholder="代买人昵称"
                    :rules="[{ validator, message: '请输入汉字、英文或数字' }]" clearable :maxlength="50" style="border-radius: 8px 8px 0 0;"/>
                <van-field v-model="addressInfo.agentCellPhone" name="validator" label="电话" placeholder="代买人手机号"
                    :rules="[{ validator: validatorTel, message: '请输入正确的手机号' }]" clearable />

                <van-field readonly clickable name="area" :value="value" label="地区" placeholder="选择省 / 市 / 区"
                    @click="showArea = true" right-icon="arrow" :rules="[{ required: true, message: '请选择地区' }]" />
                <van-popup v-model="showArea" position="bottom" round>
                    <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
                </van-popup>
                <van-field v-model="addressInfo.details" rows="1" autosize type="textarea"  name="详细地址" label="详细地址" placeholder="街道门派、楼层房间号等信息"
                    :rules="[{ required: true, message: '请填写详细地址' }]" clearable  :maxlength='100' style="border-radius: 0 0 8px 8px;"/>
                <div style="margin: 16px;">
                    <van-button round block color="#EE0A25" native-type="submit">保存</van-button>
                </div>
            </van-form>
            <van-overlay :show="isLoading">
                <div class="wrapper">
                    <loading v-if="isLoading == true"></loading>
                </div>
            </van-overlay>
        </div>
    </div>
</template>
<script>
import { AddressEdit, Toast, Notify, Overlay, Dialog, Form, Field, Button, Popup, Area } from "vant";
import AreaList from "../../config/area";
import service from "../../api/buyAgent";
import loading from "../../components/loading/loading";
export default {
    components: {
        [AddressEdit.name]: AddressEdit,
        [Toast.name]: Toast,
        [Notify.name]: Notify,
        [Overlay.name]: Overlay,
        [Dialog.Component.name]: Dialog.Component,
        [Form.name]: Form,
        [Field.name]: Field,
        [Button.name]: Button,
        [Popup.name]: Popup,
        [Area.name]: Area,
        loading
    },
    data() {
        return {
            value: '',
            showArea: false,
            isLoading: true, //loading状态
            areaList: AreaList,
            isSaving: false,
            addressInfo: {},
            type: "update"
        };
    },
    methods: {
        validatorTel(e) {
            let myreg2 = /^[0-9]\d{10}$/;
            if (!myreg2.test(e)) {
                Notify({
                    type: "danger",
                    message: "手机格式不正确"
                });
                return false;
            } else {
                console.log('手机号正确')
                return true
            }
        },
        validator(e) {
            
            // var reg = /^\S+$/;
            var reg = /^[0-9a-zA-Z\u4E00-\u9FA5]+$/;
            console.log(e,reg.test(e),74)
            if (!reg.test(e)) {
                return false;
            } else {
                return true
            }
        },
        onConfirm(values) {
            this.value = values
                .filter((item) => !!item)
                .map((item) => item.name)
                .join('/');
            this.addressInfo.province = values[0].name
            this.addressInfo.city = values[1].name
            this.addressInfo.district = values[2].name
            this.addressInfo.districtCode = values[2].code
            this.showArea = false;
            this.isSaving = false;

        },
        onSubmit() {
            this.isLoading = true;
            if (this.type == "update") {
                service
                    .updateAddress(this.addressInfo)
                    .then(() => {
                        this.isSaving = false;
                        this.$router.go(-1);
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 500);
                    })
                    .catch((err) => {
                        Toast(err);
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 500);
                    });
            } else {
                service
                    .addGroup(this.addressInfo)
                    .then((res) => {
                        // if(res.statusCode == 200){
                          this.isSaving = false;
                        this.$router.go(-1);  
                        this.isLoading = false;
                        // }else{
                        //     Toast(res.errors);
                        //     this.isLoading = false;
                        // }                        
                    })
                    .catch((err) => {
                        Toast(err);
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 500);
                    });
            }
        },

        init() {
            if (this.$route.query.type == "update") {
                service
                    .getDetail(this.$route.query.id)
                    .then((response) => {
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 500);
                        let tAddressInfo = {};
                        tAddressInfo = {
                            id: response.data.id,
                            agentCellPhone: response.data.cellPhone,
                            province: response.data.province,
                            city: response.data.city,
                            district: response.data.district,
                            details: response.data.details,
                            districtCode: response.data.districtCode
                        };
                        this.value =response.data.province+'/'+response.data.city+'/'+response.data.district
                        this.addressInfo = tAddressInfo;
                        // this.addressInfo = response.data;
                        this.type = "update";
                    })
                    .catch((error) => {
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 500);
                        if (error.status == 404) {
                            this.showEmpty = true;
                        }
                    });
            } else {
                this.type = "add";
                setTimeout(() => {
                    this.isLoading = false;
                }, 500);
            }
        }
    },

    mounted() {
        this.init();
    }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.container {
    // position: fixed;
    // height: calc(100% - 18.6vw);
    overflow-x: hidden;
    height: 100vh;

    // background: #f7f7f7;
    .agentAdd {
        padding: 12px;
        border-radius: 8px;
       
        @{deep}.van-field .van-field__label {
            width: 60px;
            margin-right: 2.2vw;
            flex: none;
        }

        .van-field .van-cell__value {
            text-align: left;
        }

        @{deep}.van-cell {
            padding-top: 4vw;
            padding-bottom: 4vw;
        }
    }
}
</style>